<div layout-vertical layout-full-width padding-lr>
  <div class="row-wrap" padding-tb-small-x layout layout-align-items-center layout-space-between>
    <div class="heading-wrap" layout layout-align-items-center>
      @if (rating.rating) {
        <rt-interview-evaluation-rating [rating]="rating.rating" [tooltip]="true">
        </rt-interview-evaluation-rating>
      }
      @if (!rating.rating) {
        <span
          [rtTooltip]="'app.interview.no_score' | translate"
          [rtTooltipPosition]="'above'"
          margin-left-small-x
          text-weight-semi-bold
        >
          ―
        </span>
      }
    </div>
    <div class="rating-wrap" layout layout-full-width>
      <div
        [rtTooltip]="rating.count.toString()"
        [rtTooltipPosition]="'right'"
        class="rating"
        layout
        layout-align-items-center
      >
        {{ this.percentRating }}
      </div>
      <div class="rating-bar-wrap" layout layout-align-items-center padding-lr layout-full-width>
        <div [class.gray]="isGray()" [style.width.%]="calculateWidth()" class="rating-bar"></div>
      </div>
      <rt-group class="admins-wrap">
        <rt-admins-avatars
          [admins]="$any(adminsWithGuests)"
          [renderAdminTooltip]="renderAdminTooltip"
          [editable]="false"
          [limit]="4"
        >
        </rt-admins-avatars>
      </rt-group>
    </div>
  </div>
  <rt-divider></rt-divider>
</div>
